

export default function ImgsSwiper({ img }) {
  return (
    img ?
    <>
      <div className="h-[35vh] absolute top-0 md:hidden">
        <img src={img}
             style={{
               width: document.body.offsetWidth,
               height: document.body.offsetWidth
             }}/>
      </div>
    </> : null
  );
}
